<template>
  <footer>
    <div class="fixed">
      <h2 class="club" v-if="clubLogo">
        <div class="item" :style="`background-image: url(${clubLogo});`">
          {{ $t('footer.clubLogo') }}
        </div>
      </h2>
    </div>
  </footer>
</template>

<script>
import {settingService, userService} from '../../router'

export default {
  name: 'footerLayout',
  data () {
    return {
      clubLogo: ''
    }
  },
  created: function () {
    userService.getAll().then(response => {
      this.userInfo = response.data
      if (this.userInfo.userRole === 'ClubManager') {
        settingService.getClubLogo(this.userInfo.ccode).then(response => {
          let clubLogo = response.data.clubLogo
          if (clubLogo) this.clubLogo = clubLogo.image_data
        }).catch(error => {
          console.log('getClubInfoList.err.===>', error)
        })
      }
    })
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue